var showAllGroups, showSameGroup, showSameLayerGroups, toggleFilterRoles;

toggleFilterRoles = function(event) {
  var boxes, checked, target;
  target = $(event.target);
  boxes = target.nextUntil('.filter-toggle').find(':checkbox');
  checked = boxes.filter(':checked').length === boxes.length;
  boxes.each(function(el) {
    return $(this).prop('checked', !checked);
  });
  return target.data('checked', !checked);
};

showAllGroups = function(radio) {
  if (radio.checked) {
    return $('.layer, .group').slideDown();
  }
};

showSameLayerGroups = function(radio) {
  if (radio.checked) {
    $('.layer').hide();
    $('.layer:not(.same-layer) input[type=checkbox]').prop('checked', false);
    $('.same-layer').show();
    return $('.same-layer .group').slideDown();
  }
};

showSameGroup = function(radio) {
  if (radio.checked) {
    $('.layer, .group').hide();
    $('.layer:not(.same-layer) input[type=checkbox], .group:not(.same-group) input[type=checkbox]').prop('checked', false);
    return $('.same-layer, .same-group').show();
  }
};

$(document).on('click', '.filter-toggle', toggleFilterRoles);

$(document).on('change', 'input#range_deep', function(e) {
  return showAllGroups(e.target);
});

$(document).on('change', 'input#range_layer', function(e) {
  return showSameLayerGroups(e.target);
});

$(document).on('change', 'input#range_group', function(e) {
  return showSameGroup(e.target);
});

$(document).on('turbo:load', function() {
  $('input#range_deep').each(function(i, e) {
    return showAllGroups(e);
  });
  $('input#range_layer').each(function(i, e) {
    return showSameLayerGroups(e);
  });
  return $('input#range_group').each(function(i, e) {
    return showSameGroup(e);
  });
});
